import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { BeamerHelmet } from 'react-beamer';
import { BackTop, Drawer, Layout, Alert } from "antd";
import moment from "moment";
import enquire from "enquire.js";
import { generalActions } from "./../redux/actions";
import MainNavigation from "./../navigations/mainNavigation";
import UserDropdownNavigation from "./../navigations/userDropdownNavigation";
import { withRouter } from "react-router-dom";
import CompanyDropdown from "../components/CompanyDropdown";
import TermOfUseModal from "../screens/TermOfUseModal";
import ChatPrompt from '../components/ChatPrompt';
import { companiesService } from "../redux/services";

const { Content, Header, Sider } = Layout;
const BYPONTO_BEAMER_TOKEN = 'pWCBcAgk79348';

class DefaultTemplate extends Component {
	constructor(props) {
		super(props);

		this.state = {
			siderBarDrawer: false,
			isEqualOrLassThanThiryDays: false,
			remainingDays: 0,
			showTermModal: false,
		};

		this.mdSideBarOn  = "screen and (max-width: 1199px)";
		this.mdSideBarOff = "screen and (min-width: 1200px)";
	}

	componentDidMount() {
		enquire.register(this.mdSideBarOn, () => {
			this.setState({
				siderBarDrawer: true,
			})
		});

		enquire.register(this.mdSideBarOff, () => {
			this.setState({
				siderBarDrawer: false,
			})
		});

		this.checkHasThirtyDaysOrLess();
	};

	componentDidUpdate(prevProps) {
		if (prevProps.isLoadingUserData && !this.props.isLoadingUserData) {
			if (!this.props.user.aceitou_termo) {
				this.setState({ showTermModal: true });
			}
		}
	}

	checkHasThirtyDaysOrLess() {
		const companyData = JSON.parse(localStorage.getItem('@mainCompany'));
		
		if (!companyData) return;

		companiesService.getDueDate().then(({data}) => {
			const dueDate = data.vencimento;
			const today = new Date();

			const diffDays = moment(dueDate).diff(today, 'days');
		
			if (diffDays <= 30) {
				this.setState({
					isEqualOrLassThanThiryDays: true,
					remainingDays: diffDays
				})
			}
		})
	}

	componentWillUnmount() {
		enquire.unregister(this.mdSideBarOn);
		enquire.unregister(this.mdSideBarOff);
	};

	toggle = () => {
		this.props.siderToggle(!this.props.siderCollapsed);
	};

	render() {
		const { siderBarDrawer, isEqualOrLassThanThiryDays, remainingDays, showTermModal } = this.state;
		const { siderCollapsed, user, client, access_token } = this.props; 
		const siderWidth = siderBarDrawer ? 0 : (siderCollapsed ? 80 : 256);
		const menuDisabled = this.props.location.pathname.startsWith("/impressao");

		return (
			<Fragment>
				{!menuDisabled ? (

					<Layout className="template-default">
						{!menuDisabled && (
							siderBarDrawer ? (
								<Drawer
									placement="left"
									closable={false}
									onClose={this.toggle}
									open={!siderCollapsed}
									className="template-default-ant-drawer site-menu">
									<div className="logo">
										<img src="/images/logos/byPonto-logocomplete.png" alt="byponto-logo" width={200} />
									</div>
									<MainNavigation
										onClick={this.toggle}
									/>
								</Drawer>
							) : (
								<Sider
									theme="dark"
									trigger={null}
									collapsible={true}
									collapsed={siderCollapsed}
									breakpoint="lg"
									width={265}
									collapsedWidth={80}
									className="site-menu">
									<div className="logo" >
										<img style={{ width: '75%' }} src="/images/logos/byPonto-logocomplete.png" alt="byponto-logo" width={150} />
										<img src="/images/logos/logo-byponto.svg" className="logo-icon" alt="" />
									</div>
									<MainNavigation />
								</Sider>
							)
						)}
						<Layout style={{paddingLeft: !menuDisabled ? siderWidth : 0}}>
							{!menuDisabled && (
								<Header key="1" className="site-header" style={{ left: siderWidth }}>
									<i className={`trigger ${siderCollapsed ? "fad fa-indent" : "fad fa-outdent"}`} onClick={this.toggle} />
									<div className="inner">
										<CompanyDropdown />

										<BeamerHelmet
											id={BYPONTO_BEAMER_TOKEN}
											args={{
												user_id: user?.id,
												embed: false,
												selector: 'beamer',
												display: 'none',
												top: 15,
											}}
										/>

										<span id="beamer" style={{ cursor: 'pointer' }}>
											<i className="fad fa-bell" style={{ fontSize: 18, padding: '0 24px', lineHeight: '64px' }} />
										</span>

										<UserDropdownNavigation />
									</div>
									{
										isEqualOrLassThanThiryDays && (
											<Alert message={`Faltam ${ remainingDays } dias para o vencimento da sua assinatura. Entre em contato com seu revendedor para realizar a renovação.`} type="warning" />
										)
									}
								</Header>
							)}
							<Content className="site-content">
								{this.props.children}
							</Content>
							<BackTop />
						</Layout>
					</Layout>
				) : (
					// Impressão
					<Fragment>
						{this.props.children}
					</Fragment>
				)}

				{!menuDisabled && process.env.REACT_APP_ENABLE_PROMPT_CHAT === 'true' && (
					<ChatPrompt
						title="Suporte IA ByPonto"
						provider="byponto"
						token={access_token}
						user={user}
						client={client}
						color="#00C9FF"
						modes={["orientation", "execution"]}
					/>
				)}

				<TermOfUseModal
                    visible={showTermModal}
                    onClose={() => this.setState({ showTermModal: false })}
                />
			</Fragment>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		siderCollapsed: state.general.siderCollapsed,
		user: state.auth.userData,
		client: state.auth.client,
		access_token: state.auth.access_token,
		isLoadingUserData: state.auth.isLoadingUserData,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		siderToggle: (collapsed) => {
			dispatch(generalActions.siderToggle(collapsed));
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DefaultTemplate));
